var render, staticRenderFns
import script from "./ColumnSlot.vue?vue&type=script&lang=js&"
export * from "./ColumnSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports